// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"WY-z","subtitle":"XY-z","wrapper":"YY-z","leftArrow":"ZY-z","rightArrow":"_Y-z"};